<template>
  <div
    id="divDashboardHeader"
    class="container-fluid">
    <div
      id="divDashboardSubheader"
      class="row rd-gridsystem-scrollbar-wrap">
      <div class="rdResponsiveColumn col-lg-9 col-md-8 col-sm-12 col-xs-12 ">
        <div
          v-if="printerFriendly"
        >
          <h3>{{ systemName }}</h3>
        </div>
        <h3>Category: {{ GSGo.category }}</h3>
        <div
          v-if="!printerFriendly "
          id="divQuestionSelector"
          class="QuestionSelector">
          <h4>Indicator</h4>
          <label
            for="islIndicator"
            class="accessibleHide ">Indicator</label>
          <select
            v-if="indicators.length> 1"
            id="islIndicator"
            v-model="indicatorId"
            class="rdThemeInput">
            <option
              v-for="item in indicators"
              :key="item.id"
              :value="item.id">{{ item.abbr }}</option>
          </select>
          <span v-else>{{ indicator }}</span>
          <span
            v-if="showDebugIds"
            class="debugIds">{{ indicatorId }}</span>
        </div>
      </div>
      <div
        v-if="!printerFriendly"
        class="rdResponsiveColumn col-lg-3 col-md-4 col-sm-12 col-xs-12 pr-0 pl-0">
        <div class="linkbucketcontainer">
          <div class="lbspacer"/>
          <link-bucket/>
        </div>
      </div>
      <div
        v-if="printerFriendly"
        class="rdResponsiveColumn col-lg-3 col-md-4 col-sm-12 col-xs-12 pflogo">
        <img
          src="../../assets/Shared.Images.hhs-cdc-logo.png"
          alt="CDC logo">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';
import LinkBucket from './LinkBucket';
import helper from '../../helper';

export default {
  components: {
    LinkBucket,
  },
  data() {
    return {
      indicatorId: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'IndicatorId'),
    };
  },
  computed: {
    ...mapState([
      'lpgsLink',
    ]),
    ...mapState({
      GSGo: state => state.LP.GSGo,
      goClicked: state => state.LP.flags.goClicked,
      showDebugIds: state => state.flags.showDebugIds,
      showFootnotes: state => state.LP.flags.showFootnotes,
      initialPageLoad: state => state.flags.initialPageLoad,
      lku: state => state.lku,
    }),
    ...mapGetters([
      'printerFriendly',
    ]),
    indicators() {
      return _(this.lpgsLink).filter({
        c: this.GSGo.categoryId,
      }).map('q').uniq()
        .map(id => this.lku.Question[id])
        .orderBy('sort', 'asc')
        .value();
    },
    indicator() {
      // const row = _(this.indicators).find({ id: this.indicatorId });
      const row = this.lku.Question[this.indicatorId];
      return row ? row.name : '';
    },
    systemName() {
      return process.env.SystemName;
    },
  },
  watch: {
    indicators: {
      handler() {
        const newIndicatorId = helper.defaultOrFirstId(
          this.indicators,
          this.indicatorId,
          true,
        );
        this.indicatorId = newIndicatorId;
      },
      // run this watch handler immediately after the start of observation
      // so that when the indicatorId is set when the DashboardHeader is first
      // displayed after filling in an empty global selector and clicking the
      // Go button.
      immediate: true,
    },
    indicatorId: {
      handler() {
        // handler(val, oldVal) {
        // console.log('indicatorId watch val: %s, oldVal: %s', val, oldVal);
        // console.log('indicatorId watch goClicked %s',
        //   this.goClicked, performance.now());
        if (this.goClicked) {
          // load api call immediately
          // this.setGoClicked(false);
          this.$store.commit('LP/setGoClicked', false);
          // this.getQuestionDataAndSetIndicatorId(this.indicatorId);
          this.$store.dispatch('LP/getQuestionDataAndSetIndicatorId', this.indicatorId);

          // this.getIndicatorAllIdsAndSetIndicatorId(this.indicatorId);
        } else {
          this.$store.commit('LP/setInteractionTypeIfEmpty', 'II');
          // debounce to limit rate of api calls when change indicator dropdown using arrow keys
          this.getIndicatorAllIdsAndSetIndicatorIdDebounce();
        }
      },
      // run this watch handler immediately after the start of observations
      // so the api call is handled with the go button is first clicked after the
      // page is first loaded
      immediate: true,
    },
  },
  // created() {
  //   console.log('DashboardHeader created', performance.now());
  // },
  methods: {
    getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey) {
      return this.$store.getters
        .getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey);
    },
    ...mapMutations([
      // 'setLoadingIndicatorAllIds',
      'setGoClicked',
    ]),
    ...mapActions([
      // 'getIndicatorAllIdsAndSetIndicatorId',
      'getQuestionDataAndSetIndicatorId',
    ]),
    getIndicatorAllIdsAndSetIndicatorIdDebounce:
        _.debounce(function fnToDebounce() {
          // this.getIndicatorAllIdsAndSetIndicatorId(this.indicatorId);
          // this.getQuestionDataAndSetIndicatorId(this.indicatorId);
          this.$store.dispatch('LP/getQuestionDataAndSetIndicatorId', this.indicatorId);
        }, process.env.DebounceDelay),
  },
};
</script>

<style scoped>
  h3 {
    margin: 0;
  }
  .pflogo {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/LP/DashboardHeader.vue